import React, {useEffect, useState} from 'react';
import { Col, Container, Row } from 'reactstrap';
import ModelProduct from '../../../../Models/Product';
import {connect} from "react-redux";
import Images from "./components/Images";
import ModalUploadImage from "./components/ModalUploadImage";
import {showNotification} from "../../../../shared/components/Notification";

const ProductArticles = ({ dispatch, images,rtl,theme }) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const vm = new ModelProduct();

    useEffect(() => {
        // vm.getVenueData(venueId).then(async response => {
        //     if (response.data.status === 'failed') {
        //         alert('failed');
        //         return false;
        //     }
        //     return true;
        // });
        //
        // vm.getVenueImages(venueId).then(response => {
        //     if (response.data.status === "failed") {
        //         showNotification(theme,'danger',rtl,'Get Images',response.data.msg);
        //         return false;
        //     }
        //     setIsLoaded(true);
        //     return true;
        // });

    },[]);

    const handleGenTest=()=>{
        vm.generateArticle().then(response=>{
           console.log(response);
        });
    };

    return (

            <Container className="dashboard">
                <Row className={"pb-2"}>
                    <Col md={12}>
                        {/*<h3 className="page-title">Product Images{venueData.v_name}</h3>*/}
                        <h3 className="page-title">Product Images</h3>
                    </Col>
                </Row>
                <Row>
                    <button onClick={handleGenTest}>gen</button>
                    <Col md={3} className={'mb-4'}>
                        <ModalUploadImage />
                    </Col>
                </Row>
                <Row>
                    {isLoaded &&
                        <Images/>
                    }
                </Row>
            </Container>

    );
}

export default connect(state => ({
    rtl: state.rtl,
    theme: state.theme,
    images:state.product.images,
}))(ProductArticles);